
import { Modal, View } from "native-base";
import { Platform, Text, TouchableHighlight } from "react-native";
import Feather from '@expo/vector-icons/Feather';

export const LoginTip = ({
  open,
  setOpen,
  onChange
}:{
  open: boolean;
  setOpen: (open: boolean) => void;
  onChange: ()=> void;
}) => {
  return (
    <Modal isOpen={open} size="full" bg="black.700:alpha.70"
      justifyContent="center" alignItems="center"
      style={{
        width: "100%", maxWidth: 460,
        marginLeft: "auto", marginRight: "auto",
      }}>
      <Modal.CloseButton _icon={{ color: "white" }} position="absolute"
        right={2} top={Platform.OS === 'ios' ? 12 : 2} zIndex={2}
        onPress={()=>{setOpen(false)}} />

      <View style={{ width: "100%", alignItems: "center" }}>
        <Feather name="user" size={80} color="rgb(203,99,255)"
          style={{ fontWeight: "900" }} />
        <Text style={{
          color: "#FFFFFF", fontSize: 24, fontWeight: "bold",
          marginTop: 16, textAlign: "center"
        }}>
          please log in first
        </Text>
        <Text style={{
          color: "#FFFFFF", fontSize: 14, fontWeight: "bold",
          marginBottom: 10, marginTop: 4,
          textAlign: "center"
        }}>
          Unlock more exciting content
        </Text>
        <View style={{ padding: 10, marginTop: 10 }}>
          <TouchableHighlight style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
            width: 200,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            alignItems: "center", justifyContent: "center"
          }} onPress={onChange}>
            <Text style={{
              fontSize: 18, color: "#FFFFFF", fontWeight: "700"
            }}>
              Sign In
            </Text>
          </TouchableHighlight>
          <TouchableHighlight style={{
            paddingLeft: 10, paddingRight: 10, marginTop: 10
          }} onPress={onChange}>
            <Text style={{
              fontSize: 18, color: "rgb(173,8,255)", fontWeight: "700",
              textAlign: "center"
            }}>
              Sign Up
            </Text>
          </TouchableHighlight>
          <Text style={{
            fontSize: 12, color: "#EEEEEE", textAlign: "center", marginTop: 10
          }}>
            300 Bonus Coins for New User
          </Text>
        </View>
      </View>
    </Modal>
  )
};